import React from "react";
import styled from "styled-components";

const Row = styled.label`
  display: inline-flex;
  align-items: center;
  gap: var(--space-3);
  font-family: var(--font-sans);
  font-size: var(--font-size-base);
  color: var(--color-text);
  cursor: pointer;
  user-select: none;
  padding: var(--space-1) 0;

  &:has(input:disabled) {
    cursor: not-allowed;
    color: var(--color-text-tertiary);
  }
`;

const Hidden = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
`;

const Track = styled.span`
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
  border-radius: var(--radius-pill);
  background: var(--color-border-strong);
  transition: background var(--duration-fast) var(--ease-standard);
  flex-shrink: 0;

  &::after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    background: var(--color-surface);
    border-radius: 50%;
    transition: transform var(--duration-base) var(--ease-emphasized);
    box-shadow: var(--shadow-xs);
  }

  ${Hidden}:checked + & {
    background: var(--color-accent);
  }

  ${Hidden}:checked + &::after {
    transform: translateX(16px);
  }

  ${Hidden}:focus-visible + & {
    box-shadow: var(--shadow-focus);
  }

  ${Hidden}:disabled + & {
    opacity: 0.5;
  }
`;

type CheckboxProps = {
  label?: string;
  value?: boolean;
  onChange?: any;
  name?: string;
  disabled?: boolean;
  [k: string]: any;
};

const Checkbox = (props: CheckboxProps) => {
  const { label, value, onChange, name, disabled, ...rest } = props;
  return (
    <Row>
      <Hidden
        type="checkbox"
        checked={Boolean(value)}
        onChange={onChange}
        name={name}
        disabled={disabled}
        {...rest}
      />
      <Track />
      {label && <span>{label}</span>}
    </Row>
  );
};

export default Checkbox;
